import { createSlice } from '@reduxjs/toolkit';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';

import { Context } from '@alltrails/shared/types/context';
import User from '@alltrails/shared/types/User';

import { Group } from '../../../types/groups';

type CurrentUser = User & {
  id: number;
  proUser?: boolean;
  mobileBrowser?: boolean;
  tabletBrowser?: boolean;
};

export type AuthState = Context & {
  adminUser: boolean;
  groups: Group[];
  currentUser: CurrentUser | null;
  displayMetric: boolean;
  languageRegionCode: LanguageRegionCode;
  primaryAlgoliaIndexId: string;
  alertsAlgoliaIndexId: string;
};

const initialContextState = {
  featureFlags: {
    rttcFeatureFlag: false
  },
  mobileBrowser: false,
  proUser: false,
  tabletBrowser: false
};

export const initialState: AuthState = {
  ...initialContextState,
  adminUser: false,
  currentUser: null,
  groups: [],
  displayMetric: false,
  languageRegionCode: LanguageRegionCode.English,
  primaryAlgoliaIndexId: null,
  alertsAlgoliaIndexId: null
};

export const authStateSlice = createSlice({
  name: 'authState',
  initialState,
  reducers: {}
});

export default authStateSlice.reducer;
